import React, { createContext, useState } from "react";

export const ProfileSection = createContext();

const ProfileContextProvider = (props) => {
  const [profilePage, setProfilePage] = useState({
    firstPage: true,
    settingPage: false,
    changePassPage: false,
    usersSetting: false,
    homeEdit: false,
    setting: false,
    privacy: false,
    contactUs: false,
    howUse: false,
    roles: false,
    deviceMine: false,
    deviceInfo: false,
    editDeviceName: false,
  });

  const ProfileShowHideFunc = (page) => {
    switch (page) {
      case "firstPage":
        setProfilePage({
          firstPage: true,
          settingPage: false,
          changePassPage: false,
          usersSetting: false,
          homeEdit: false,
          setting: false,
          privacy: false,
          contactUs: false,
          howUse: false,
          roles: false,
          deviceMine: false,
          deviceInfo: false,
          editDeviceName: false,
        });
        break;
      case "settingPage":
        setProfilePage({
          firstPage: false,
          settingPage: true,
          changePassPage: false,
          usersSetting: false,
          homeEdit: false,
          setting: false,
          privacy: false,
          contactUs: false,
          howUse: false,
          roles: false,
          deviceMine: false,
          deviceInfo: false,
          editDeviceName: false,
        });
        break;
      case "changePassPage":
        setProfilePage({
          firstPage: false,
          settingPage: false,
          changePassPage: true,
          usersSetting: false,
          homeEdit: false,
          setting: false,
          privacy: false,
          contactUs: false,
          howUse: false,
          roles: false,
          deviceMine: false,
          deviceInfo: false,
          editDeviceName: false,
        });
        break;
      case "usersSetting":
        setProfilePage({
          firstPage: false,
          settingPage: false,
          changePassPage: false,
          usersSetting: true,
          homeEdit: false,
          setting: false,
          privacy: false,
          contactUs: false,
          howUse: false,
          roles: false,
          deviceMine: false,
          deviceInfo: false,
          editDeviceName: false,
        });
        break;
      case "homeEdit":
        setProfilePage({
          firstPage: false,
          settingPage: false,
          changePassPage: false,
          usersSetting: false,
          homeEdit: true,
          setting: false,
          privacy: false,
          contactUs: false,
          howUse: false,
          roles: false,
          deviceMine: false,
          deviceInfo: false,
          editDeviceName: false,
        });
        break;
      case "setting":
        setProfilePage({
          firstPage: false,
          settingPage: false,
          changePassPage: false,
          usersSetting: false,
          homeEdit: false,
          setting: true,
          privacy: false,
          contactUs: false,
          howUse: false,
          roles: false,
          deviceMine: false,
          deviceInfo: false,
          editDeviceName: false,
        });
        break;
      case "privacy":
        setProfilePage({
          firstPage: false,
          settingPage: false,
          changePassPage: false,
          usersSetting: false,
          homeEdit: false,
          setting: false,
          privacy: true,
          contactUs: false,
          howUse: false,
          roles: false,
          deviceMine: false,
          deviceInfo: false,
          editDeviceName: false,
        });
        break;
      case "contactUs":
        setProfilePage({
          firstPage: false,
          settingPage: false,
          changePassPage: false,
          usersSetting: false,
          homeEdit: false,
          setting: false,
          privacy: false,
          contactUs: true,
          howUse: false,
          roles: false,
          deviceMine: false,
          deviceInfo: false,
          editDeviceName: false,
        });
        break;
      case "howUse":
        setProfilePage({
          firstPage: false,
          settingPage: false,
          changePassPage: false,
          usersSetting: false,
          homeEdit: false,
          setting: false,
          privacy: false,
          contactUs: false,
          howUse: true,
          roles: false,
          deviceMine: false,
          deviceInfo: false,
          editDeviceName: false,
        });
        break;
      case "roles":
        setProfilePage({
          firstPage: false,
          settingPage: false,
          changePassPage: false,
          usersSetting: false,
          homeEdit: false,
          setting: false,
          privacy: false,
          contactUs: false,
          howUse: false,
          roles: true,
          deviceMine: false,
          deviceInfo: false,
          editDeviceName: false,
        });
        break;
      case "deviceMine":
        setProfilePage({
          firstPage: false,
          settingPage: false,
          changePassPage: false,
          usersSetting: false,
          homeEdit: false,
          setting: false,
          privacy: false,
          contactUs: false,
          howUse: false,
          roles: false,
          deviceMine: true,
          deviceInfo: false,
          editDeviceName: false,
        });
        break;
      case "deviceInfo":
        setProfilePage({
          firstPage: false,
          settingPage: false,
          changePassPage: false,
          usersSetting: false,
          homeEdit: false,
          setting: false,
          privacy: false,
          contactUs: false,
          howUse: false,
          roles: false,
          deviceMine: false,
          deviceInfo: true,
          editDeviceName: false,
        });
        break;
      case "editDeviceName":
        setProfilePage({
          firstPage: false,
          settingPage: false,
          changePassPage: false,
          usersSetting: false,
          homeEdit: false,
          setting: false,
          privacy: false,
          contactUs: false,
          howUse: false,
          roles: false,
          deviceMine: false,
          deviceInfo: false,
          editDeviceName: true,
        });
        break;
    }
  };

  return (
    <>
      <ProfileSection.Provider value={{ profilePage, ProfileShowHideFunc }}>
        {props.children}
      </ProfileSection.Provider>
    </>
  );
};

export { ProfileContextProvider };
